import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import i18n from "../../i18n/i18n";

interface LanguageState {
  lang: string;
}

function getInitialLang(): string {
  const stored = localStorage.getItem("lang");
  if (stored) return stored;

  // Fallback to i18n language if available
  const i18nLang = i18n.language?.split("-")[0]; // normalize (e.g. "en-US" -> "en")
  if (i18nLang === "et" || i18nLang === "en") return i18nLang;

  return "en"; // final fallback
}

const initialLang = getInitialLang();

const languageSlice = createSlice({
  name: "language",
  initialState: { lang: initialLang } as LanguageState,
  reducers: {
    setLanguage(state, action: PayloadAction<string>) {
      const newLang = action.payload === "et" ? "et" : "en"; // normalize unexpected values
      state.lang = newLang;
      i18n.changeLanguage(newLang);
      localStorage.setItem("lang", newLang);
    },
  },
});

export const { setLanguage } = languageSlice.actions;
export default languageSlice.reducer;
